import React from "react";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import ElementPicker from "../../Misc/ElementPicker";
import Scrollpane from "../../Misc/Scrollpane";
import MaintStruct from "./MaintStruct";
import MaintList from "./MaintList";
import MaintDetail from "./MaintDetail";
export default class Maint extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      customListKey: "",
      rights: {},
      elementPickShow: false,
      elementPickShipId: null,
    };
  }

  componentDidMount() {
    this.assignRights();
  }

  componentDidUpdate() {
    this.renderButtons();
  }

  assignRights = () => {
    this.setState(
      {
        rights: {
          manageMaint: true,
          manageStructure: true,
        },
      },
      () => this.renderButtons()
    );
  };

  onAfterItemSave = () => {
    this.setState({ customListKey: this.context.key() });
  };

  onElementPickOpen = (callback, shipId) => {
    this.setState({
      elementPickShow: true,
      elementPickCallback: callback,
      elementPickShipId: shipId,
    });
  };

  onElementPickClose = () => {
    this.setState({ elementPickShow: false });
  };

  renderButtons = () => {
    const { structureId, itemId } = this.props;

    let showAddButton = this.state.rights.manageMaint;
    if (structureId === "any") {
      showAddButton = false;
    }

    this.context.actionsSet(
      <>
        {/*itemId && (
          <div
            onClick={() =>
              this.context.redirect(`/maint/${structureId}/${itemId}/clone`)
            }
            title="Клонировать ТО"
            className="btn btn-icon btn-light mr-2"
          >
            <i className="fa fa-clone"></i>
          </div>
          )*/}
        {/*itemId && (
          <div
            onClick={() =>
              this.context.redirect(`/act_maintenance/add/?maint=${itemId}`)
            }
            title="Акт выполнения ТО"
            className="btn btn-icon btn-light mr-2"
          >
            <i className="fa fa-check-square-o"></i>
          </div>
          )*/}
        {showAddButton && (
          <div
            onClick={() => this.context.redirect(`/maint/${structureId}/add`)}
            title="Добавить ТО"
            className={`btn ${
              this.state.mode === "add" ? "btn-light-primary" : "btn-light"
            } p-2  mr-2`}
          >
            <span className="flaticon2-add-1 px-2 align-middle"></span>
          </div>
        )}
      </>
    );
  };

  render() {
    return (
      <>
        <ElementPicker
          onElementPick={this.state.elementPickCallback}
          onClose={this.onElementPickClose}
          show={this.state.elementPickShow}
          shipId={this.state.elementPickShipId}
          allowShipChange
          keepModal
          {...this.state.rights}
        />
        <CrumbsProvider title="Конструктор ТО" link="/maint/" />
        <div className="row h-100">
          <div
            className="col-lg-3 border-right no-print"
            style={{ width: "10px" }}
          >
            <Scrollpane>
              <MaintStruct {...this.props} {...this.state.rights} />
            </Scrollpane>
          </div>
          <div className="col-lg-3 border-right no-print">
            <Scrollpane>
              <MaintList
                {...this.props}
                customListKey={this.state.customListKey}
              />
            </Scrollpane>
          </div>
          <div className="col h-100">
            <Scrollpane>
              {this.props.itemId && (
                <MaintDetail
                  {...this.props}
                  {...this.state.rights}
                  onAfterSave={this.onAfterItemSave}
                  onElementPickOpen={this.onElementPickOpen}
                />
              )}
            </Scrollpane>
          </div>
        </div>
      </>
    );
  }
}
